import { createContext, ReactNode, useContext } from 'react'

export interface AuthConfigContextValues {
  domain: string
  mfaDomain: string
  audience: string
  clientId: string
  redirectUri: string
  basename?: string
}
const AuthConfigContext = createContext<AuthConfigContextValues | null>(null)

interface AuthEnviromentProviderProps extends AuthConfigContextValues {
  children: ReactNode
}

export function AuthConfigProvider({ children, ...props }: AuthEnviromentProviderProps) {
  return <AuthConfigContext.Provider value={props}>{children}</AuthConfigContext.Provider>
}

export function useAuthConfig() {
  const values = useContext(AuthConfigContext)

  if (values === null) {
    throw new Error('useAuthEnviroment must be used within a AuthEnviromentProvider')
  }

  return values
}
